import { create } from 'zustand';
import type { ProjectListItem } from './api';

export type ProjectRole = ProjectListItem['role'];

interface CurrentProjectState {
  projectId: string | null;
  baseVersion: number;
  title: string | null;
  /** Caller's role on the current project. null until a project opens. */
  role: ProjectRole | null;
  /** The server rejected a REST save because this project is live-sync-owned
   *  (the client is running with sync opted out). Drives the upgrade banner;
   *  autosave short-circuits while set. */
  syncUpgradeRequired: boolean;
  setCurrent: (projectId: string, baseVersion: number, title: string) => void;
  setRole: (role: ProjectRole) => void;
  setSyncUpgradeRequired: (v: boolean) => void;
  clear: () => void;
}

/** Tracks which project the canvas is currently bound to + the server version
 *  the local doc derives from (used by autosave to send baseVersion) + the
 *  caller's role (drives viewer read-only UX). */
export const useCurrentProject = create<CurrentProjectState>((set) => ({
  projectId: null,
  baseVersion: 0,
  title: null,
  role: null,
  syncUpgradeRequired: false,
  setCurrent: (projectId, baseVersion, title) => set({ projectId, baseVersion, title }),
  setRole: (role) => set({ role }),
  setSyncUpgradeRequired: (v) => set({ syncUpgradeRequired: v }),
  clear: () => set({ projectId: null, baseVersion: 0, title: null, role: null, syncUpgradeRequired: false }),
}));
